import { Dialog } from "primereact/dialog";

import { SummaryLogsProps } from "./summaryLogsConsts";
import { TransferLogs } from "../../../../lich-su-truyen-nhan/component/TransferLogs";
import { convertDataPeriod } from "../../invoiceSummaryUtils";
import { ODataPeriod } from "../../../../../shared/constants";
import moment from "moment";

export const SummaryLog = ({
  open,
  onHide,
  invoiceSummaryData,
}: SummaryLogsProps) => {
  return (
    <Dialog
      header={`Lịch sử truyền nhận. Số BTH: ${
        invoiceSummaryData?.summaryDataNumber
      }. Kỳ dữ liệu: ${convertDataPeriod(invoiceSummaryData?.dataPeriod)} ${
        invoiceSummaryData?.dataPeriod !== ODataPeriod.DAY
          ? `${invoiceSummaryData?.monthOrQuarter} năm ${invoiceSummaryData?.year}`
          : ""
      }${
        invoiceSummaryData?.dataPeriod === ODataPeriod.DAY
          ? `${moment(invoiceSummaryData.dataPeriodDate).format("DD/MM/YYYY")}`
          : ""
      }
        `}
      onHide={onHide}
      visible={open}
      style={{ maxWidth: "1000px", width: "100%" }}
    >
      {open && invoiceSummaryData && (
        <TransferLogs type='Summary' idAction={invoiceSummaryData.id} />
      )}
    </Dialog>
  );
};
